import { render, staticRenderFns } from "./view-document.vue?vue&type=template&id=271fb037&scoped=true"
import script from "./view-document.vue?vue&type=script&lang=js"
export * from "./view-document.vue?vue&type=script&lang=js"
import style0 from "./view-document.vue?vue&type=style&index=0&id=271fb037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271fb037",
  null
  
)

export default component.exports